// extracted by mini-css-extract-plugin
export default {"root":"ResponsiveContainer_root__I9yOt"};